<template>
    <div 
        class="table-base"
        :class="{'preloader-content': isPreloader}"
    >
        <div
            v-if="isPreloader"
            class="preloader fa fa-circle-o-notch fa-spin">
        </div>
        <table>
            <thead>
                <tr class="table-tr__section">
                    <th
                        v-for="(column, indexColumn) of Object.keys(columns)"
                        :key="indexColumn"
                        :class="{'table-multiline__td-name': indexColumn == 0 && columnTypeBorder === '' || columnTypeBorder === column}"
                    >
                        <!-- <span
                            v-if="!isSort || !Object.keys(columnsSort).includes(column)"
                            class="table-treeview__th-container txt_right"
                        >
                            {{columns[column]}}
                        </span> -->
                        <table-header
                            :isSort="isSort && Object.keys(columnsSort).includes(column)"
                            :sortState="sortColumn === column ? sortState : 0"
                            :title="columns[column]"
                            @onToggleSort="onToggleSort($event, column)"
                        />
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(row, indexRow) of rowsBuffer"
                    :key="indexRow"
                >
                    <td
                        v-for="(column, indexColumn) of Object.keys(columns)"
                        :key="indexColumn"
                        :class="{
                                'table-multiline__td-number': indexColumn !== 0 && columnTypeBorder === '' || indexColumn !== 0 && columnTypeBorder !== column,
                                'table-multiline__td-name' : indexColumn === 0 && columnTypeBorder === '' || columnTypeBorder === column,
                            }"
                    >
                        <span
                                v-if="isObjectCell && indexColumn !== 0"
                                class="table-multiline__cell-val"
                                :class="{
                                    'table-base__td-number': typeof row[column]['val'] !== 'undefined' && row[column]['val'] !== null && (typeof row[column]['val'] === 'number' || row[column]['val'].indexOf('%') !== -1)
                                }"
                        >
                            {{
                                typeof row[column]['val'] === 'number' ? row[column]['val'].toLocaleString('ru-RU') : row[column]['val']
                            }}
                        </span>
                        <span
                                v-if="isObjectCell  && indexColumn !== 0 && typeof row[column]['diff'] !== 'undefined'"
                                class="table-multiline__cell-diff"
                                :class="{
                                    'table-base__td-number': typeof row[column]['diff'] !== 'undefined' && row[column]['diff'] !== null && (typeof row[column]['diff'] === 'number' || row[column]['diff'].indexOf('%') !== -1)
                                }"
                        >
                            {{
                                typeof row[column]['diff'] === 'number' ? row[column]['diff'].toLocaleString('ru-RU') : row[column]['diff']
                            }}
                        </span>
                        <span
                                v-if="!isObjectCell || indexColumn === 0"
                                class="table-multiline__cell-val"
                                :class="{
                                    'table-base__td-number': typeof row[column] !== 'undefined' && row[column] !== null && (typeof row[column] === 'number' || row[column].indexOf('%') !== -1)
                                }"
                        >
                            {{
                                typeof row[column] === 'number' ? row[column].toLocaleString('ru-RU') : row[column]
                            }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import TableHeader from './TableHeader';
import mixinTable from '../../mixins/mixinTable';
export default {
    name: 'TableBase',
    components: {
        TableHeader
    },
    mixins: [
        mixinTable
    ],
    /**
     * Входные данные компонента
     * @property {object} columns - колонки
     * @property {object} rows - строки
     * @property {boolean} isPreloader - условие показа прелоадера
     * @property {boolean} isSort - вкл/откл сортировку
     * @property {object} columnsSort - колонки которые можно сортировать
     * @property {boolean} isObjectCell - является ли значение ячейки объектом
     * @property {string} columnTypeBorder - колонка с правой границей
     */
    props: {
        columns: {
            type: Object,
            default: () => ({})
        },
        rows: {
            type: Array,
            default: () => ([])
        },
        isPreloader: {
            type: Boolean,
            default: false
        },
        isSort: {
            type: Boolean,
            default: false
        },
        columnsSort: {
            type: Object,
            default: () => ({})
        },
        isObjectCell: {
            type: Boolean,
            default: false
        },
        columnTypeBorder: {
            type: String,
            default: ''
        }
    },
    /**
     * данные компонента
     * @property {array} rowsBuffer - буферный массив строк
     */
    data: () => ({
        rowsBuffer: [],
    }),
    mounted() {
        this.rowsBuffer = this.rows.slice();
    },
    watch: {
        /**
         * следим за обновлением строк из пропса и обновляем буферный массив
         */
        rows: function() {
            this.rowsBuffer = this.rows.slice();
            this.sortState = 0;
            this.sortColumn = '';
        }
    },
    methods: {
        /**
         * переключение режима сортировки
         * @param {string} currentSortState - текущее состояние режима сортировки
         * @param {string} column - колонка по которой сортируем
         */
        onToggleSort(currentSortState, column) {
            if(currentSortState === Object.keys(this.sortStates).length - 1)
                this.sortState = 0;
            else
                this.sortState = currentSortState + 1;
            this.sortColumn = column;
            let typeSort = this.sortStates[this.sortState].type;
            if (typeSort === 'none') {
                this.rowsBuffer = this.rows;
            }
            else {
                if (this.columnsSort[column].typeColumn === 'Number')
                    this.rowsBuffer = this.sortNumberArray(typeSort, this.rowsBuffer.slice(), column, this.isObjectCell);
                if (this.columnsSort[column].typeColumn === 'String')
                    this.rowsBuffer = this.sortStringArray(typeSort, this.rowsBuffer.slice(), column);
                if (this.columnsSort[column].typeColumn === 'Percent')
                    this.rowsBuffer = this.sortPercentArray(typeSort, this.rowsBuffer.slice(), column);
                if (this.columnsSort[column].typeColumn === 'Month')
                    this.rowsBuffer = this.sortMonthArray(typeSort, this.rowsBuffer.slice(), column);
            }
        },
        /**
         *  проверяем число и присваиваем цвет
         * @param diff
         * @returns {string}
         */
        getColor(diff){
            if(diff < 0){
                return "color:red";
            }
            if(diff === 0){
                return "color:#cccccc";
            }
            if(diff > 0){
                return "color:green";
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .table-base {
        position: relative;
        // overflow-x: auto;

        width: 100%;
        border-radius: 10px;
        overflow-x: auto;
        border: 3px solid #f5f7f9;
    }
    /*.table-base table {*/
    /*    border-collapse: collapse;*/
    /*    width: 100%;*/
    /*}*/
    /*.table-base th {*/
    /*    font-family: Arial;*/
    /*    font-weight: bold;*/
    /*    text-align: left;*/
    /*    border: 1px solid #ddd;*/
    /*    padding: 5px 5px 5px 5px;*/
    /*}*/
    /*.table-base__th-container {*/
    /*    display: flex;*/
    /*    justify-content: space-between;*/
    /*    align-items: center;*/
    /*}*/
    /*.table-base td {*/
    /*    border: 1px solid #ddd;*/
    /*    padding: 5px 5px 5px 5px;*/
    /*}*/
    /*.table-base__td-number {*/
    /*    text-align: right;*/
    /*}*/
    /*.table-base__sort {*/
    /*    visibility: hidden;*/
    /*}*/
    /*.table-base th:hover .table-base__sort{*/
    /*    visibility: visible;*/
    /*}*/
    /*.table-base__sort_active {*/
    /*    visibility: visible;*/
    /*}*/
    /*.table-base__cell-val{*/
    /*    display: block;*/
    /*}*/
    /*.table-base__cell-diff{*/
    /*    display: block;*/
    /*    font-size: 12px;*/
    /*}*/
    table {
        width: 100%;
        border-radius: 10px;
        overflow: hidden;
        border-collapse: collapse;
        border-spacing: 0;
    }

    thead th,
    tbody td {
        border-bottom: 1px solid #f5f7f9;
    }

    thead th,
    tbody td {
        padding: 16px 14px;
    }

    thead th {
        text-align: left;
        font-weight: bold;
        text-transform: uppercase;
        color: #000;
        letter-spacing: 0.07em;
        word-break: break-all;
        font-size: 0.65em;
    }

    .table-treeview__th-container {
        cursor: pointer;
    }

    thead {
        border-bottom: 3px solid #f5f7f9;
    }

    // .table-tr__section {
    //     background: #f5f7f9;
    // }

    thead th.table-multiline__td-name,
    tbody td.table-multiline__td-name {
        border-right: 3px solid #f5f7f9;
    }

    tbody tr.tr__sub {
        background: #fbfbfb;
    }

    tbody tr:last-child td {
        border-bottom: 0;
    }

    tbody tr.tr__sub.tr__sub-two {
        background: #fff;
    }

    tbody tr.tr__sub.tr__sub-three {
        background: #fff;
    }

    tbody tr.tr__sub td:first-child {
        padding-left: 36px;
    }

    tbody tr.tr__sub.tr__sub-two td:first-child {
        padding-left: 64px;
    }

    tbody tr.tr__sub.tr__sub-three td:first-child {
        padding-left: 93px;
    }

    tbody tr:hover {
        background: #f5f7f9 !important;
    }

    .table-multiline__td-number {
        text-align: right;
        position: relative;
        white-space: nowrap;
    }

    .table-multiline__cell-val {
        display: block;
    }

    .table-multiline__cell-diff {
        display: block;
        font-size: 0.65em;
        color: #b0b1b4;
        opacity: 0;
        visibility: hidden;
        position: absolute;
        right: 14px;
        bottom: 4px;
    }

    tbody tr:hover .table-multiline__cell-diff {
        opacity: 1;
        visibility: visible;
    }

    .table_plus {
        cursor: pointer;
        border: 1px solid #f5f7f9;
        width: 16px;
        height: 16px;
        text-align: center;
        line-height: 14px;
        border-radius: 3px;
        font-size: 10px;
        margin-right: 10px;
        color: #b0b1b4;
        background: #fff;
        transition: all 250ms;
    }

    .table_plus:hover {
        background: #fe1060;
        color: #fff;
        border-color: #fe1060;
    }

    .txt_right {
        text-align: right;
    }
    .table-treeview__th-container {
        cursor: pointer;
    }
</style>